import { routerPostCall } from '../../axios';

const submitRequest = (state, params) => {
  const url = `/cms/request/submitRequest`;
  return routerPostCall(state, url, params);
};

export default { submitRequest };
